<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-row class="pri-row p-5">
      <b-col cols="9" offset="1">
        <h1>PRI Simulation</h1>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Client">
              <v-select
                :searchable="true"
                :clearable="true"
                label="text"
                code="value"
                :class="$v.clientId.$error ? 'border border-danger rounded' : null"
                v-model="$v.clientId.$model"
                :state="$v.clientId.$dirty ? !$v.clientId.$error : null"
                aria-describedby
                :options="clients"
                @input="getThirdPartiesList"
                placeholder="Select Any Company"
              ></v-select>
            </b-form-group>
            <label>Pri</label>
            <b-input-group>
              <template v-slot:prepend>
                <b-button
                  :disabled="!clientId"
                  variant="outline-success"
                  @click="showAddModalFunction"
                  style="display: flex;"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>
              </template>
              <v-select
                :searchable="true"
                :clearable="false"
                label="title"
                code="id"
                :class="$v.priId.$error ? 'border border-danger rounded' : null"
                v-model="$v.priId.$model"
                :state="$v.priId.$dirty ? !$v.priId.$error : null"
                aria-describedby
                :options="$store.state.clientAllPriOptions ? $store.state.clientAllPriOptions : priOptions"
                @input="onSelectedPri"
                placeholder="Select Any PRI"
                style="width: 82%; height: 100%;"
              ></v-select>
              <b-input-group-append>
                <b-button
                  :disabled="!selectedPriId"
                  @click="showSettingPriModal"
                  variant="primary"
                  style="display: flex;"
                >
                  <font-awesome-icon icon="cog" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Third Party">
              <b-form-radio-group
                class="mb-3"
                v-model="selectedThirdPartyOption"
                :options="thirdPartyOption"
                name="radio-options"
              ></b-form-radio-group>
              <v-select
                v-if="selectedThirdPartyOption=='existing'"
                :searchable="true"
                :clearable="true"
                label="text"
                code="value"
                :class="$v.thirdPartyId.$error ? 'border border-danger rounded' : null"
                v-model="$v.thirdPartyId.$model"
                :state="$v.thirdPartyId.$dirty ? !$v.thirdPartyId.$error : null"
                aria-describedby
                :options="thirdPartyOptions"
                placeholder="Select Any Third Party"
                @input="setSearchValue"
              ></v-select>
            </b-form-group>

            <b-form-group label="Entity Type" v-if="selectedThirdPartyOption=='new'">
              <b-form-radio-group v-model="entityType" :options="['O','P']"></b-form-radio-group>
            </b-form-group>

            <b-form-group
              label="Date of birth"
              v-if="selectedThirdPartyOption=='new' && entityType=='P'"
            >
              <b-form-datepicker id="example-datepicker" v-model="dob" class="mb-2"></b-form-datepicker>
            </b-form-group>
            <b-form-group
              v-if="selectedThirdPartyOption=='new' && entityType=='P'"
              id="fieldset-1"
              label-cols-sm="4"
              label-cols-lg="3"
              label="Country of birth"
              class="text-left mt-3"
            >
              <v-select
                class="mb-2"
                label="name"
                v-model="countryOfBirth"
                :options="optionsCountries"
              >
                <template slot="option" slot-scope="option">
                  <country-flag v-if="option.icon" :country="option.icon" size="small" />
                  <span>{{ '&nbsp;'+ option.name }}</span>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group
              v-if="selectedThirdPartyOption=='new' && entityType=='P'"
              id="fieldset-1"
              label-cols-sm="4"
              label-cols-lg="3"
              label="Nationality"
              class="text-left mt-3"
            >
              <v-select class="mb-2" label="name" v-model="nationality" :options="optionsCountries">
                <template slot="option" slot-scope="option">
                  <country-flag v-if="option.icon" :country="option.icon" size="small" />
                  <span>{{ '&nbsp;'+ option.name }}</span>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group
              v-if="selectedThirdPartyOption=='new' && entityType=='P'"
              id="fieldset-1"
              label-cols-sm="4"
              label-cols-lg="3"
              label="Place of birth"
              class="text-left mt-3"
            >
              <v-select
                class="mb-2"
                label="name"
                v-model="placeOfBirth"
                :options="optionsCountries"
              >
                <template slot="option" slot-scope="option">
                  <country-flag v-if="option.icon" :country="option.icon" size="small" />
                  <span>{{ '&nbsp;'+ option.name }}</span>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group label="Address" v-if="selectedThirdPartyOption=='new' && entityType=='P'">
              <b-form-textarea
                id="textarea"
                v-model="address"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group
              label="Company Registration Number"
              v-if="selectedThirdPartyOption=='new' && entityType=='O'"
            >
              <b-form-input v-model="companyRegistrationNumber" type="number" placeholder></b-form-input>
            </b-form-group>

            <b-form-group
              v-if="selectedThirdPartyOption=='new'"
              id="fieldset-1"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="(entityType == 'O') ? 'Country of Registration' : ' Country of Residence'"
              label-for="input-1"
              class="text-left mt-3"
            >
              <v-select
                class="mb-2"
                label="name"
                v-model="underSearch.countryValue"
                :options="optionsCountries"
                @input="onSetCountry"
              >
                <template slot="option" slot-scope="option">
                  <country-flag v-if="option.icon" :country="option.icon" size="small" />
                  <span>{{ '&nbsp;'+ option.name }}</span>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group
              label="Website Address"
              v-if="selectedThirdPartyOption=='new' && entityType=='O'"
            >
              <b-form-input v-model="websiteAddress" type="text" placeholder></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-input-group class="mb-3 mt-2">
          <b-form-input
            v-model="searchEntityNameText"
            type="text"
            placeholder="Enter the entity name you would like to search..."
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="outline-success" @click="showSearchModal">Search</b-button>
          </b-input-group-append>
        </b-input-group>
        <hr />
        <h5>Client Custom Fields (Business Risks)</h5>
        <b-row v-for="(customField, index) in customFields" :key="customField.id" class="my-1">
          <b-col cols="3" class="text-left text-capitalize">
            {{customField.tp_customatt}}
            <b-badge v-if="customField.tp_pri_indicator == 1" variant="warning">
              PRI
              <font-awesome-icon icon="calculator"></font-awesome-icon>
            </b-badge>
          </b-col>
          <b-col v-if="customFields.length">
            <!-- @input="onDropdownSetCustomField($event, customField.tp_customatt)" -->

            <v-select
              v-if="customField.tp_type == 'Dropdown'"
              :searchable="true"
              :clearable="true"
              :options="optionsForCustomFields[index][customField.id]"
              v-model="optionsForCustomFields[index].selectedValue"
              label="tp_values"
            ></v-select>
            <!-- @input="onMultiselectSetCustomField($event, customField.tp_customatt)" -->

            <v-select
              v-if="customField.tp_type == 'Multiselect'"
              :searchable="true"
              :clearable="true"
              :multiple="true"
              :options="optionsForCustomFields[index][customField.id]"
              v-model="optionsForCustomFields[index].selectedValue"
              label="tp_values"
            ></v-select>

            <v-select
              v-if="customField.tp_type == 'Country List'"
              :searchable="true"
              :clearable="true"
              :options="optionsForCustomFields[index][customField.id]"
              v-model="optionsForCustomFields[index].selectedValue"
              label="tp_values"
            ></v-select>

            <Datepicker
              v-if="customField.tp_type == 'Date'"
              input-class="custom-date-picker"
              calendar-class="date-calender"
              class="form-control"
              v-model="optionsForCustomFields[index].selectedValue"
            ></Datepicker>

            <b-form-input
              v-if="customField.tp_type == 'Text'"
              v-model="optionsForCustomFields[index].selectedValue"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-form-group
          v-for="(indicator,index) in indicators"
          :key="index"
          id="fieldset-1"
          label-cols-sm="4"
          label-cols-lg="3"
          :label="indicators[index].indicatorTitle"
          label-for="input-1"
          class="text-left mt-3"
        >
          <v-select class="mb-2" label="text" :options="indicators[index].indicatorOptions"></v-select>
          <template slot="option" slot-scope="option">
            <span>{{ option.text }}</span>
          </template>
        </b-form-group>

        <!-- end form -->

        <AddPriComponent />
      </b-col>

      <b-alert
        v-model="showErrorToast"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000;"
        variant="danger"
        dismissible
        solid
      >Error</b-alert>
      <b-modal
        id="modal-1"
        title="Add new indicator"
        v-model="showIndicatorModal"
        @ok="createIndicator"
        ok-title="Create"
      >
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          label="Indicator Name"
          label-for="input-1"
          class="text-left"
        >
          <b-form-input type="text" v-model="indicatorTitle" trim></b-form-input>
        </b-form-group>
      </b-modal>
    </b-row>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Submit Search"
      v-model="showSubmitSearchModal"
    >
      <div>
        <div v-if="showErrorToast">
          <p class="text-danger">Submit Error</p>
        </div>
        <div v-else-if="!submiting && !responseSuccess">
          <p>You are about to submit your search</p>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Search is being submiting......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Your Search has been submited successfully and queued for processing. We will notify you once PRI creation is complete.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" variant="outline-danger" @click="resetSearchSubmitModal">Close</b-button>
        <b-button
          v-if="!submiting && responseSuccess && !showErrorToast"
          to="/pri-searches"
          variant="outline-info"
        >View Searches</b-button>
        <b-button
          v-if="!submiting && responseSuccess && !showErrorToast"
          :to="'/pri-search/'+responseSearchId"
          variant="success"
        >Go to Search</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="submitSearch()"
        >Submit</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../utils/HTTP";
import countriesData from "../utils/countryCodes.json";
import AppLoader from "../components/Loader/Loader";
// import SearchResult from "../components/negative-media/search-results.vue";
import vSelect from "vue-select";
// import _ from "lodash";
// import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { EventBus } from "@/event-bus.js";
import AddPriComponent from "../components/Pri/addPriModal/addPriModal.vue";

export default {
  name: "mediaSearchPage",
  mixins: [validationMixin],
  components: {
    vSelect,
    // SearchResult,
    AppLoader,
    Datepicker,
    AddPriComponent
    //   ClientsVueContainer
  },
  data() {
    return {
      countryOfBirth: null,
      placeOfBirth: null,
      address: null,
      dob: null,
      nationality: null,
      websiteAddress: null,
      selectedThirdPartyOption: "new",
      thirdPartyOption: ["new", "existing"],
      responseSearchId: null,
      submiting: false,
      responseSuccess: false,
      showSubmitSearchModal: false,
      clients: [],
      clientId: null,
      thirdPartyId: null,
      thirdPartyOptions: [],
      priOptions: [],
      priId: null,
      indicatorTitle: null,
      showIndicatorModal: false,
      optionsCountries: countriesData.countries,
      indicators: [],
      tabCounter: 0,
      showErrorToast: false,
      searchEntityNameText: null,
      entityType: null,
      companyRegistrationNumber: null,
      name: null,
      isEditing: false,
      selectedIndex: null,
      totalResults: null,
      googleResults: [],
      isLoading: false,
      sort: 0,
      selectedStart: 1,
      indicatorOptText: null,
      indicatorOptValue: null,

      //for rules
      ruleField: null, // v-model for select 1
      conditionalRuleValue: null, // v-model for select 2
      customCondition: null, // v-model for select 3
      selectionRules: [],
      noORules: [1],
      selectedIndicatorOption: [],
      setOfConditions: [
        {
          text: "Greater than",
          value: 0
        },
        {
          text: "Less than",
          value: 0
        },
        {
          text: "Greater than equals to",
          value: 0
        },
        {
          text: "Less than equals to",
          value: 0
        }
      ],

      availableIndicators: [
        {
          text: "Negative Media",
          value: 0,
          key: "negative"
        },
        {
          text: "Country",
          value: 0,
          key: "country"
        },
        {
          text: "Industry",
          value: 0,
          key: "industry"
        }
      ],

      customFields: [],
      selectedPriId: null,
      modifiedSearch: 0,
      showAddPriModal: false,
      underSearch: {
        countryValue: null
      },
      customAtMultiselect: undefined,
      selectedCustomMultiselect: [],
      selectMetaData: [],
      selectedDropdownCustomField: [],
      selectedMultiselectCustomField: [],
      selectedCountryValue: [],
      selectedCountryData: {},
      optionsForCustomFields: [
        {
          id: null,
          data: [
            {
              text: null,
              value: null
            }
          ]
        }
      ]
    };
  },

  validations: {
    clientId: {
      required
    },
    thirdPartyId: {
      required
    },
    priId: {
      required
    }
  },

  computed: {},

  mounted() {
    this.getClientsList();
    //   this.getCustomFields();
  },
  methods: {
    onSetCountry() {
      this.selectedCountryValue = this.underSearch.countryValue;
      // console.log("countrydata", this.underSearch);
      this.selectedCountryData = this.underSearch;
    },

    onDropdownSetCustomField(e, customAtName) {
      let indexOfIndicator = this.selectedDropdownCustomField.findIndex(
        i => i.value == customAtName && e.tp_values == i.data.tp_values
      );
      if (indexOfIndicator == -1) {
        this.selectedDropdownCustomField.push({
          value: customAtName,
          data: e
        });
      } else {
        this.selectedDropdownCustomField.splice(indexOfIndicator, 1);
      }
    },

    onMultiselectSetCustomField(e, customAtName) {
      // console.log("onMultiselectSetCustomField", e, customAtName);
      // this.customAtMultiselect = this.customAtMultiselect[customAtName];
    },

    showSearchModal() {
      // // console.log(
      //   "selectedDropdownCustomField:-",
      //   this.selectedDropdownCustomField
      // );
      // // console.log(
      //   "onMultiselectSetCustomField:-",
      //   this.selectedCustomMultiselect
      // );
      // this.selectMetaData = [
      //   {
      //     customAtValue: this.selectedCustomField,
      //     country: this.selectedCountryValue
      //   }
      // ];

      this.showSubmitSearchModal = true;
      // this.$v.$touch();
      // if (this.$v.$anyError) {
      //   return;
      // } else {
      //   this.showSubmitSearchModal = true;
      // }
    },

    // age(value) {
    //   let localeData = moment.updateLocale("en", {
    //     relativeTime: {
    //       future: "in %s",
    //       past: "%s ago",
    //       s: "hello, a few seconds",
    //       ss: "%d seconds",
    //       m: "a minute",
    //       mm: "%d minutes",
    //       h: "an hour",
    //       hh: "%d hours",
    //       d: "a day",
    //       dd: "%d days",
    //       M: "a month",
    //       MM: "%d months",
    //       y: "a year",
    //       yy: "%d years"
    //     }
    //   });
    //   //return moment(value).fromNow();

    //   return moment(value).fromNow();
    // },

    async getClientsList() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("get", "v1/getclientslist", null, {
          Authorization: token
        });

        this.clients = result.data.clients;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    async getCustomFields() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/pri/getcustomfields/" + this.clientId.value,
          null,
          {
            Authorization: token
          }
        );

        //  // console.log("customFields", result.data.data[0].tp_customatt_values)
        this.customFields = result.data.data;
        this.optionsForCustomFields = [];
        if (result.data.data && result.data.data.length) {
          result.data.data.map(attr => {
            // // console.log("attr", attr);
            this.optionsForCustomFields.push({
              id: attr.id,
              [attr.id]: attr.tp_customatt_values,
              selectedValue: null
            });
          });
        }
        //  // console.log("customFields", this.optionsForCustomFields)

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    async getThirdPartiesList() {
      this.thirdPartyOptions = [];
      this.customFields = [];
      this.thirdPartyId = null;
      this.getPriList();
      this.getCustomFields();
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/getthirdPartieslist/" + this.clientId.value,
          null,
          {
            Authorization: token
          }
        );
        if (this.clientId != null) {
          this.thirdPartyOptions = result.data.thirdparty;
        } else {
          this.thirdPartyOptions = [];
          this.thirdPartyId = null;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    async getPriList() {
      this.$store.state.clientAllPriOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/getprilist/" + this.clientId.value,
          null,
          {
            Authorization: token
          }
        );
        if (this.clientId != null) {
          this.$store.state.clientAllPriOptions = result.data.pri;
          //  // console.log("pppaaaa", JSON.parse(this.priOptions[0].configuration));
        } else {
          this.$store.state.clientAllPriOptions = [];
        }
        let soundAlert = new Audio(
          "http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3"
        );
        soundAlert.play();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    setSearchValue() {
      if (this.thirdPartyId != null) {
        this.searchEntityNameText = this.thirdPartyId.text;
        this.entityType = this.thirdPartyId.entityType;
        this.companyRegistrationNumber = this.thirdPartyId.company_number;
      } else {
        this.searchEntityNameText = null;
      }
    },

    addNewIndicatorOption(index) {
      this.indicators[index].indicatorOptions.push({
        text: "option " + index,
        value: "option " + index
      });
    },

    addNewIndicator() {
      this.showIndicatorModal = true;
    },

    createIndicator() {
      this.tabCounter++;
      this.indicators.push({
        indicatorTitle: this.indicatorTitle,
        indicatorValue: 0,
        indicatorOptions: [],
        show: true,
        fields: ["text", "value"]
      });
      let strKey = this.indicatorTitle.replace(/\s/g, ""); // regex to remove all white spaces
      // // console.log("strKey", strKey)
      // this.defaultIndicators.push({text: this.indicatorTitle, value: 0, key: strKey})
      this.availableIndicators.push({
        text: this.indicatorTitle,
        value: 0,
        key: strKey
      });
      // this.disableValues[strKey] = true
      this.indicatorTitle = null;
    },

    // getDateFromArticle(article) {
    //   let snippet = article.snippet;
    //   let data = snippet.split("...");
    //   return data[0];
    // },

    removeName(index) {
      this.keywords.splice(index, 1);
    },
    async submitSearch() {
      // // console.log(
      //   "selectedDropdownCustomField",
      //   this.selectedDropdownCustomField
      // );
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.googleResults = [];
      try {
        this.submiting = true;
        this.isLoading = true;
        let thirdPartyId =
          (this.thirdPartyId && this.thirdPartyId.value) || null;
        let postData = {
          searchEntityNameText: this.searchEntityNameText,
          // keywordPhraseMatch: this.selectedKeywords,
          exactTerms: this.exactTerms,
          // excludeTerms: this.selectedExcludeTerms,
          language: this.selectedLanguage,
          start: this.selectedStart,
          sort: this.sort,
          userId: localStorage.getItem("userId"),
          companyId: this.clientId.value,
          third_party_id: thirdPartyId,
          pri_type_id: this.priId.id,
          meta_data: this.selectMetaData ? this.selectMetaData : [],
          pri_configuration: this.form,
          is_modified: this.modifiedSearch,
          selectedCustomFieldValues: this.optionsForCustomFields,
          countryData: this.selectedCountryData,
          entity_type: this.entityType,
          companyNumber: this.companyRegistrationNumber,
          thirdPartyOption: this.selectedThirdPartyOption,
          futureRisks: {
            searchKeywords: [
              "policy",
              "policies",
              "anti-corruption",
              "bribery",
              "code of conduct"
            ],
            websiteAddress: this.websiteAddress
          }
        };
        // // console.log("post data on submit", this.optionsForCustomFields);
        let result = await HTTP(
          "post",
          "v1/pri/calculate",
          postData,
          {
            Authorization: token
          },
          null,
          true
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.thirdPartyId = null;
        this.searchEntityNameText = null;
        this.companyRegistrationNumber = null;
        this.$v.$reset();
        this.responseSearchId = result.data.searchId;
        let soundAlert = new Audio(
          "https://eb2.ethixbase.com/public/sounds/sound2.ogg"
        );
        soundAlert.play();
      } catch (err) {
        // console.log(err);
        this.isLoading = false;
        this.submiting = false;
        this.showErrorToast = true;
        let soundAlert = new Audio(
          "https://eb2.ethixbase.com/public/sounds/sound5.ogg"
        );
        soundAlert.play();
      }
    },
    //for rules
    setRules() {},

    addMoreRules() {
      this.noORules.push(1);
    },

    removeRules(index) {
      // console.log("index", index);
      this.noORules.splice(index, 1);
    },
    onSelectCondition(selectedCondition) {
      // console.log("onSelectCondition", selectedCondition);
    },

    //for score
    setScore(e) {
      this.sumScore();
    },

    onSelectedPri(pri) {
      if (pri) {
        let configuration = JSON.parse(pri.configuration);
        this.form = configuration;
        this.seletedPridata = pri;
        this.selectedPriId = pri.id;
      } else {
        this.selectedPriId = null;
      }
    },

    showSettingPriModal() {
      EventBus.$emit(
        "onShowEditModalOnPriSimulationPage",
        this.seletedPridata,
        this.clientId.value
      );
    },
    showAddModalFunction() {
      EventBus.$emit("onShowAddModalOnPriSimulationPage", this.clientId.value);
    },
    resetSearchSubmitModal() {
      this.showSubmitSearchModal = false;
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.pri-row {
  height: calc(100vh - 150px);
  overflow-y: scroll;
}
</style>
